var exports = {
  "zr": "TavlaBoard.module__root___dThyQX",
  "KE": "TavlaBoard.module__toolbar___dThyQX",
  "aR": "TavlaBoard.module__dice___dThyQX",
  "F_": "TavlaBoard.module__die___dThyQX",
  "O1": "TavlaBoard.module__timer___dThyQX",
  "no": "TavlaBoard.module__board___dThyQX",
  "zx": "TavlaBoard.module__point___dThyQX",
  "ai": "TavlaBoard.module__number___dThyQX",
  "w1": "TavlaBoard.module__checker___dThyQX",
  "U9": "TavlaBoard.module__count___dThyQX",
  "M0": "TavlaBoard.module__bar___dThyQX",
  "AU": "TavlaBoard.module__off___dThyQX",
  "o1": "TavlaBoard.module__actions___dThyQX",
  "z3": "TavlaBoard.module__error___dThyQX",
};

module.exports = exports;
